import { DEFAULT_VAN_COLOR_BG, DEFAULT_VAN_COLOR_FONT } from "../common/constants";

export class ProfileUpdate{
    breakTime: string = "";
    driverName: string = "";
    gemsid: string = "";
    latitude: string = "";
    longitude: string = "";
    onBreak: boolean = false;
    type: string = "profileUpdate";
    vanBgColorPref: any = DEFAULT_VAN_COLOR_BG;
    vanDriverInitialsPref: string = "";
    vanDriverVanNumberPref: string = "";
    vanFontColorPref: any = DEFAULT_VAN_COLOR_FONT;
}